import { createContext, useContext } from 'react';
import { DragEvent, StanDraggableItem } from './StanDraggable.types';

export interface StanDraggableContextValue {
    onReorder: (event: DragEvent) => void;
    onDragStart?: (event: DragEvent) => void;
    onDragEnd?: (event: DragEvent) => void;
    disabled?: boolean;
    direction?: 'vertical' | 'horizontal';
    gap?: 'none' | 'sm' | 'md' | 'lg';
    dragFromHandleOnly?: boolean;
}

export const StanDraggableContext = createContext<StanDraggableContextValue | null>(null);

export const useStanDraggableContext = () => {
    const context = useContext(StanDraggableContext);
    if (!context) {
        throw new Error('useStanDraggableContext must be used within a StanDraggable component');
    }
    return context;
};

export interface StanDraggableItemContextValue {
    item: StanDraggableItem;
    index: number;
    isDragging: boolean;
    isOverlay: boolean;
}

export const StanDraggableItemContext = createContext<StanDraggableItemContextValue | null>(null);

export const useStanDraggableItemContext = () => {
    const context = useContext(StanDraggableItemContext);
    if (!context) {
        throw new Error('useStanDraggableItemContext must be used within a StanDraggableItem component');
    }
    return context;
};
